"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Picture = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Picture = props => {
  const texts = [props.description, props.copyright ? `${props.translate('pictures-gallery.copyright')}: ${props.copyright}` : null];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'picture'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'image-area'
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: props.src
  })), Boolean(texts.filter(text => text).length) && /*#__PURE__*/_react.default.createElement("p", null, texts.join(' ')));
};
exports.Picture = Picture;
Picture.propTypes = {
  src: _propTypes.default.string.isRequired,
  translate: _propTypes.default.func,
  copyright: _propTypes.default.string,
  description: _propTypes.default.string
};
var _default = exports.default = Picture;